import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getBookingRates } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormRates = () => {

    const { t } = useTranslation('booking');

    const ratesQuery = useQuery({
        queryKey: [ReactQueryKey.BookingRates],
        queryFn: getBookingRates,
        enabled: false
    });

    const handleOnOpen = () => {
        if(ratesQuery.data == undefined) 
            ratesQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="rates"
            label={t('label.rates')}
            options={ratesQuery.data || []}
            loading={ratesQuery.isLoading}
            multiple
            isOptionEqualToValue={(option, value) => option.code === value.code}
            getOptionLabel={(option) => (option.code + ' - ' + option.label)}
            onOpen={handleOnOpen}
        />
    );
};

export default FormRates;
